import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/travelhero2.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { TopBar } from "./data/datahero";
import * as OrderApi from "api/order/OrderApi"; // or "../../api/order/OrderApi"
import OrdersStatsCompact from "./OrdersStatsCompact";
import Button from "shared/Button/Button";

type OrdersBucket = {
  total?: number;
  pending?: number;
  completed?: number;
  cancelled?: number;
};
type OrdersStats = {
  today?: OrdersBucket;
  lastMonth?: OrdersBucket;
  allTime?: OrdersBucket;
  timezone?: string;
};

export interface SectionHero3Props {
  className?: string;
  onExploreClick?: () => void;
}

const SectionHero3: FC<SectionHero3Props> = ({
  className = "",
  onExploreClick,
}) => {
  const [movies, setMovies] = useState(TopBar);
  const [noofbooking, setnoofBooking] = useState(0);
  const [noofOrder, setnoofOrder] = useState(266);
  const [orderStats, setOrderStats] = useState<OrdersStats | undefined>(
    undefined
  );

  const getNoOfOrders = async () => {
    try {
      const data = await OrderApi.getOrdersStatsService();
      console.log({ data });
      const stats = data?.response ?? data; // supports either shape
      if (!stats || typeof stats.total !== "number") {
        setnoofOrder(0);
        return;
      }
      setnoofOrder(stats?.total);
    } catch (error) {
      setnoofOrder(0);
    }
  };

  useEffect(() => {
    (async () => {
      const res = await OrderApi.getOrdersStatsService();
      setOrderStats((res as any)?.response);
    })();
  }, []);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const mobileGradient =
    "absolute inset-0 z-0 bg-[radial-gradient(500px_250px_at_0%_0%,rgba(190,18,60,0.55)_0%,transparent_65%),radial-gradient(400px_200px_at_100%_100%,rgba(190,18,60,0.55)_0%,transparent_65%)] pointer-events-none";

  const desktopGradient =
    "absolute inset-0 z-0 bg-[radial-gradient(1600px_800px_at_0%_0%,rgba(190,18,60,0.55)_0%,transparent_65%),radial-gradient(1200px_600px_at_100%_100%,rgba(190,18,60,0.55)_0%,transparent_65%)] pointer-events-none";

  return (
    <section className="relative w-full">
      {/* background behind everything (optional) */}

      <div className={`${isMobile ? mobileGradient : desktopGradient}`} />
      {/* <div className="absolute inset-0 z-0 bg-[radial-gradient(1600px_800px_at_0%_0%,rgba(190,18,60,0.55)_0%,transparent_65%),radial-gradient(1200px_600px_at_100%_100%,rgba(190,18,60,0.55)_0%,transparent_65%)] pointer-events-none" /> */}

      <div className="grid place-items-center lg:min-h-[calc(100dvh-80px)] min-h-[calc(100vh-200px)]">
        {/* make the card positioned */}
        <div className="relative z-10 mx-auto w-full max-w-[1300px] h-[60vh] lg:h-[70vh] rounded-0 lg:rounded-3xl overflow-hidden shadow-2xl ring-1 ring-black/10">
          {/* Swiper sits at the bottom of the stack */}
          <Swiper
            className="h-full w-full"
            spaceBetween={0}
            navigation={false}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            speed={2000}
            modules={[Autoplay]}
            slidesPerView={1}
            direction="vertical"
            loop
          >
            {movies.map((movie, index) => (
              <SwiperSlide key={index} className="h-full">
                <div className="relative h-full w-full">
                  <div
                    className="absolute inset-0 bg-center bg-cover z-0"
                    style={{ backgroundImage: `url("${movie.img}")` }}
                  />
                  {/* keep the darkener, but below the red gradient */}
                  <div className="absolute inset-0 bg-black/80 z-10" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Content overlay, highest z */}
          <div className="absolute inset-0 z-30 flex items-center justify-center px-4 sm:px-6 md:px-10">
            <div className="text-center space-y-4 lg:space-y-6 lg:max-w-[min(1200px,85vw)] max-w-full">
              <h2
                className="font-serif tracking-[1.4] leading-[1.15] text-[clamp(40px,5vw,64px)] text-text"
                style={{ textWrap: "balance" }}
              >
                <span className="bg-gradient-to-r from-red-500 to-rose-300 bg-clip-text text-transparent">
                  Smarter
                </span>{" "}
                local{" "}
                <span className="bg-gradient-to-r from-rose-300 to-red-500 bg-clip-text text-transparent">
                  booking
                </span>{" "}
                and{" "}
                <span className="bg-gradient-to-r from-rose-300 to-red-500 bg-clip-text text-transparent">
                  ordering
                </span>{" "}
              </h2>

              <div className="flex flex-col items-center gap-1 text-white max-w-[60vw] mx-auto space-y-2">
                <OrdersStatsCompact stats={orderStats} label="orders" />
                <OrdersStatsCompact value={noofbooking} label="appointments" />
              </div>

              <Button
                className="mt-2 bg-white/10 hover:bg-white/20 text-white hover:text-redlight hover:font-semibold ring-1 ring-white/30"
                sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
                fontSize="text-sm sm:text-base lg:text-lg font-medium"
                onClick={onExploreClick}
              >
                Explore What&apos;s On
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHero3;
